import {useContext, useEffect} from 'react'
import {createSearchParams, useSearchParams} from 'react-router-dom'
import {Row, Segmented} from 'antd'
import {NavContext} from '../../context/global_context'
import {getSessionStorageData} from '../../utils/SessionStorage'
import {useIntl} from 'react-intl'

import SystemStore from './system/context/context'
import System from './system'
import SubSystemStore from './sub_system/context/context'
import SubSystem from './sub_system'

const SystemAndSubSystem = () => {
  const intl = useIntl()
  const [value, dispatch] = useContext(NavContext)
  const [searchParams, setSearchParams] = useSearchParams()

  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`

  const tabs = [
    {
      value: 'system',
      label: intl.formatMessage({ id: 'system.tab' }),
    },
    {
      value: 'sub_system',
      label: intl.formatMessage({ id: 'subSystem.tab' }),
    },
  ]

  const defaultTab = 'system'
  const rawTab = searchParams.get('tab')
  const activeTab = tabs.some((tab) => tab.value === rawTab)
    ? rawTab
    : defaultTab

  const handleTabChange = (value) => {
    const nextParams = new URLSearchParams(searchParams)
    nextParams.set('tab', value)
    setSearchParams(nextParams, { replace: true })
  }

  useEffect(() => {
    if (rawTab && activeTab !== rawTab) {
      const nextParams = new URLSearchParams(searchParams)
      nextParams.set('tab', activeTab)
      setSearchParams(nextParams, { replace: true })
    }
  }, [rawTab])

  useEffect(() => {
    const isSystem = activeTab === 'system'
    dispatch({
      type: 'header',
      data: {
        header: intl.formatMessage({
          id: isSystem ? 'system.header' : 'subSystem.header',
        }),
        sub_header: intl.formatMessage({
          id: isSystem ? 'system.subHeader' : 'subSystem.subHeader',
        }),
        id: '',
        show_back_btn: true,
        dtc_details: {},
        vehicle: '',
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
  }, [activeTab, intl])

  return (
    <div className="page administration">
      <Row className="title">
        <Segmented
          options={tabs.map((tab) => ({ label: tab.label, value: tab.value }))}
          value={activeTab}
          onChange={handleTabChange}
        />
      </Row>

      {value?.header && (
        <div>
          {activeTab === 'system' && (
            <SystemStore>
              <System />
            </SystemStore>
          )}
          {activeTab === 'sub_system' && (
            <SubSystemStore>
              <SubSystem />
            </SubSystemStore>
          )}
        </div>
      )}
    </div>
  )
}

export default SystemAndSubSystem
